export default {
    closeBy:'',
    closeCash:'',
    closeComment:'',
    closeDiff:'',
    closeTime:'',
    closeWithDraw:'',
    duringShift:[],
    openBy:'',
    openCash:'',
    openComment:'',
    openDiff:'',
    openTime:'',
    openWithDraw:'',
    shopId:'',
    posId:'',
    currentCash:0,
    status:false, //  เปิดกะ หรือปิดกะ ดูตรงนี้
    lastShiftDate:'20230909', // เอาไว้เริ่มกะใหม่
    shiftCount:0,
    receiptNumber:'', // เอาไว้ fetch ข้อมูล
    thisPayment:[],
    thisProduct:[],
    thisCategory:[],
    thisCashier:[],
    thisCampaign:[]
}